import React from "react";
import "./About.css";
import profile from "../../Assets/profile.jpg";
import { FaAward } from "react-icons/fa";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="About">
      {/* Add a line for h5? */}
      <h2>About me</h2>

      <div className="container about_container">
        <div className="about_me">
          <div className="about_image">
            <img src={profile} alt=""></img>
          </div>
        </div>

        <div className="about_content">
          <div className="about_cards">
            <article className="about_card">
              <FaAward className="icon" />
              <h5>Experience</h5>
              <small>2+ Year</small>
            </article>
            <article className="about_card">
              <VscFolderLibrary className="icon" />
              <h5>Projects</h5>
              <small>5+ Completed</small>
            </article>
          </div>
          <p>
            I’m a Software Engineer with a strong foundation in computer science
            and a passion for building reliable, scalable software. I earned my
            Bachelor’s degree in Computer Science from McMaster University,
            where I developed strong skills in software development, algorithms,
            and data structures.
          </p>

          <p>
            I currently work at Evertz Microsystems, where I contribute to
            building and improving modern software products.
          </p>
          <a
            href="https://www.linkedin.com/in/talha-amjad01/"
            className="btn btn-primary"
          >
            Lets Connect
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
